module.exports = __webpack_public_path__ + "img/wheelio_cpg.fe12e7a5.jpg";